import moment from "moment-timezone";

/**
 * Generates time presets for TimePicker component
 * @returns {Array} Array of TimePickerPresetGroup objects
 */
export const generateTimePresets = () => {
  const presets = [
    {
      label: "Morning",
      values: generateTimeSlots(8, 11, 45, 15), // 8am-11:45am, 15-minute intervals
    },
    {
      label: "Afternoon",
      values: generateTimeSlots(12, 16, 45, 15), // 12pm-4:45pm, 15-minute intervals
    },
    {
      label: "Evening",
      values: generateTimeSlots(17, 20, 0, 15), // 5pm-8pm, 15-minute intervals
    },
  ];

  return presets;
};

/**
 * Generates time slots for a given range
 * @param {number} startHour - Starting hour (0-23)
 * @param {number} endHour - Ending hour (0-23)
 * @param {number} endMinute - Ending minute (0-59)
 * @param {number} interval - Interval in minutes
 * @returns {Array} Array of time strings in HH:mm format
 */
const generateTimeSlots = (startHour, endHour, endMinute, interval) => {
  const slots = [];
  let currentTime = moment().set({
    hour: startHour,
    minute: 0,
    second: 0,
    millisecond: 0,
  });
  const endTime = moment().set({
    hour: endHour,
    minute: endMinute,
    second: 0,
    millisecond: 0,
  });

  while (currentTime.isSameOrBefore(endTime)) {
    slots.push(currentTime.format("HH:mm"));
    currentTime.add(interval, "minutes");
  }

  return slots;
};

/**
 * Formats time for display in 12-hour format
 * @param {string} time - Time in HH:mm format
 * @returns {string} Time in h:mm A format
 */
export const formatTimeForDisplay = (time) => {
  if (!time) return "";
  return moment(time, "HH:mm").format("h:mm A");
};

/**
 * Converts 12-hour format to 24-hour format for API
 * @param {string} time - Time in h:mm A format
 * @returns {string} Time in HH:mm format
 */
export const convertTo24HourFormat = (time) => {
  if (!time) return "";
  return moment(time, "h:mm A").format("HH:mm");
};
